import $marketAxios from "@/services/config/market-axios.js";

class withdrawService {
  getWallet(data) {
    return $marketAxios.post(`/uc/asset/wallet/${data}`);
  }
  getUserData() {
    return $marketAxios.post(`/uc/approve/security/setting`);
  }
  getWithdrawRecords(data) {
    return $marketAxios.post(`/uc/withdraw/record`, data);
  }
}

export default new withdrawService();
